import { render, staticRenderFns } from "./TestRow.vue?vue&type=template&id=70efb660&scoped=true&"
import script from "./TestRow.vue?vue&type=script&lang=js&"
export * from "./TestRow.vue?vue&type=script&lang=js&"
import style0 from "./TestRow.vue?vue&type=style&index=0&id=70efb660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70efb660",
  null
  
)

export default component.exports